/* ============================================================
   Gutful storewide chrome JS — cart-drawer enhancements that must
   work on every page (the drawer is global, the PDP scripts are not).
   The inline one-time -> subscription upgrade, plus gift bundling:
   free gifts leave the cart with the pack that granted them.
   ============================================================ */
(function () {
  'use strict';
  if (window.__gfChromeBooted) return;
  window.__gfChromeBooted = true;

  /* -------------------------------------------------------------
     Cart icon → drawer, storewide. This used to live in the PDP
     script, which now only loads on the V3 product template — so the
     icon fell back to navigating to /cart everywhere else. Delegated
     so it survives drawer morphs and section reloads; the PDP script
     marks icons it has already bound, and we honour that flag.
     ------------------------------------------------------------- */
  function gfCartDrawer() { return document.getElementById('cart-drawer'); }
  document.addEventListener('click', function (e) {
    var icon = e.target.closest && e.target.closest('[data-gf-cart-icon]');
    if (!icon || icon.dataset.gfDrawerInit) return; // PDP script owns it there
    var drawer = gfCartDrawer();
    if (!drawer) return; // no drawer on this page — let the link through
    var dialog = drawer.querySelector('dialog');
    if (dialog && dialog.open) {
      e.preventDefault();
      if (typeof drawer.close === 'function') drawer.close();
      else dialog.close();
      return;
    }
    if (typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); return; }
    if (dialog && typeof dialog.showModal === 'function') { e.preventDefault(); dialog.showModal(); }
  });

  /* -------------------------------------------------------------
     Gift bundling — manifest-driven. Each subscription pack line
     carries a hidden _gf_gifts manifest ("id~plan~note|...") written
     at add-to-cart. After every cart mutation (and once on load) the
     reconciler rebuilds the required gift set from the manifests of
     the packs still in the cart: gift lines nothing requires are
     removed, required gifts that are missing are re-added — so gifts
     follow their pack in, out, and across tier switches. Subscription
     lines without a manifest never qualify gifts; orphan gift lines are
     removed instead of being retained by an unrelated subscription.
  ------------------------------------------------------------- */
  var origFetch = window.fetch.bind(window);
  var gfShopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var gfUnavailableGiftIds = {};
  var gfReconcileTimer = null;
  var gfReconcileRequested = false;
  function gfRoute(path) { return gfShopRoot + String(path || '').replace(/^\/+/, ''); }
  function gfQueueReconcile(delay) {
    if (gfReconcileTimer) window.clearTimeout(gfReconcileTimer);
    gfReconcileTimer = window.setTimeout(function () {
      gfReconcileTimer = null;
      gfReconcileGifts();
    }, delay || 0);
  }
  document.addEventListener('gutful:gift:unavailable', function (event) {
    var id = Number(event.detail && event.detail.variantId);
    if (id) gfUnavailableGiftIds[id] = true;
  });

  /* Pack removal is intercepted at the CLICK, before Horizon's own
     handler runs: the rows hide instantly and ONE update.js removes the
     pack and its gifts together. Rewriting the outgoing request was
     unreliable (Horizon's remove button doesn't post a JSON body), which
     left a window where the gifts briefly outlived their pack. */
  var gfCart = null;
  function gfSnapshot() {
    return origFetch(gfRoute('cart.js')).then(function (r) { return r.json(); }).then(function (c) { gfCart = c; return c; });
  }
  gfSnapshot().catch(function () {});

  function gfGiftKeysFor(cart, packKey) {
    var pack = cart.items.filter(function (i) { return i.key === packKey; })[0];
    var manifest = pack && pack.properties && pack.properties._gf_gifts;
    if (!manifest) return null;
    var ids = manifest.split('|').map(function (e) { return Number(e.split('~')[0]); }).filter(Boolean);
    var keep = {};
    cart.items.forEach(function (i) {
      if (i.key === packKey || !i.properties || !i.properties._gf_gifts) return;
      i.properties._gf_gifts.split('|').forEach(function (e) { keep[Number(e.split('~')[0])] = true; });
    });
    var updates = {};
    updates[packKey] = 0;
    cart.items.forEach(function (i) {
      if (!(i.properties && i.properties._gf_free_gift)) return;
      if (ids.indexOf(i.variant_id) !== -1 && !keep[i.variant_id]) updates[i.key] = 0;
    });
    return updates;
  }

  function gfRowsFor(updates) {
    var rows = [];
    Object.keys(updates).forEach(function (k) {
      document.querySelectorAll('[data-key="' + k + '"]').forEach(function (r) { rows.push(r); });
    });
    return rows;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-items__remove');
    if (!btn || !gfCart) return;
    var row = btn.closest('[data-key]');
    if (!row) return;
    var updates = gfGiftKeysFor(gfCart, row.dataset.key);
    // Only take over when this line actually carries gifts.
    if (!updates || Object.keys(updates).length < 2) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    gfRowsFor(updates).forEach(function (r) { r.style.display = 'none'; });
    origFetch(gfRoute('cart/update.js') + '?__gfsweep=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'cart-drawer-section' })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        gfCart = json;
        var origin = document.querySelector('#cart-drawer .cart-items__wrapper') || document;
        var ev = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
        ev.action = 'update';
        ev.promise = Promise.resolve({ detail: { sections: json.sections } });
        origin.dispatchEvent(ev);
        gfRefreshCartCount(true);
      })
      .catch(function () {
        gfRowsFor(updates).forEach(function (r) { r.style.display = ''; });
      });
  }, true);

  function gfRemovalWithGifts(url, init) {
    var body;
    try { body = JSON.parse(init.body); } catch (e) { return null; }
    if (Number(body.quantity) !== 0) return null;
    var key = body.id || body.line;
    if (!key) return null;
    return origFetch(gfRoute('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var target = cart.items.filter(function (i, idx) {
          return i.key === key || String(idx + 1) === String(key) || i.variant_id === Number(key);
        })[0];
        var manifest = target && target.properties && target.properties._gf_gifts;
        if (!manifest) return origFetch(url, init);
        var giftIds = manifest.split('|').map(function (e) { return Number(e.split('~')[0]); }).filter(Boolean);
        // Only drop gifts no OTHER remaining pack still requires.
        var keep = {};
        cart.items.forEach(function (i) {
          if (i === target || !i.properties || !i.properties._gf_gifts) return;
          i.properties._gf_gifts.split('|').forEach(function (e) { keep[Number(e.split('~')[0])] = true; });
        });
        var updates = {};
        updates[target.key] = 0;
        cart.items.forEach(function (i) {
          if (!(i.properties && i.properties._gf_free_gift)) return;
          if (giftIds.indexOf(i.variant_id) !== -1 && !keep[i.variant_id]) updates[i.key] = 0;
        });
        return origFetch(gfRoute('cart/update.js') + '?__gfsweep=1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates, sections: body.sections || 'cart-drawer-section' })
        });
      })
      .catch(function () { return origFetch(url, init); });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/change(\.js)?/.test(url) && url.indexOf('__gfsweep') === -1 && init && init.body) {
      var rewritten = gfRemovalWithGifts(url, init);
      if (rewritten) {
        rewritten.then(function () { setTimeout(function () { gfRefreshCartCount(true); }, 150); }, function () {});
        return rewritten;
      }
    }
    var p = origFetch(input, init);
    if (/\/cart\/(change|update|add|clear)(\.js)?/.test(url) && url.indexOf('__gfsweep') === -1) {
      var closesWhenEmpty = /\/cart\/clear(\.js)?/.test(url);
      if (!closesWhenEmpty && init && init.body) {
        try {
          var mutationBody = JSON.parse(init.body);
          if (/\/cart\/change(\.js)?/.test(url)) closesWhenEmpty = Number(mutationBody.quantity) === 0;
          if (/\/cart\/update(\.js)?/.test(url) && mutationBody.updates) {
            closesWhenEmpty = Object.keys(mutationBody.updates).some(function (key) {
              return Number(mutationBody.updates[key]) === 0;
            });
          }
        } catch (e) { /* non-JSON cart mutations do not auto-close */ }
      }
      // Header bubble must follow EVERY mutation (removals included —
      // Horizon only re-renders the drawer, not our count).
      p.then(function (response) {
        if (response.ok) setTimeout(function () { gfRefreshCartCount(closesWhenEmpty); }, 150);
      }, function () {});
      p.then(function (response) { if (response.ok) gfQueueReconcile(200); }, function () {});
    }
    return p;
  };

  function gfRefreshCartCount(closeAfterRemoval) {
    origFetch(gfRoute('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        gfCart = cart; // keep the snapshot warm for instant removals
        document.querySelectorAll('[data-gf-cart-count]').forEach(function (b) {
          b.textContent = cart.item_count;
          b.hidden = cart.item_count === 0;
        });
        // The free-shipping banner sits outside the nodes Horizon morphs,
        // so it survived an emptied cart. Keep it tied to live cart state.
        var hasSub = cart.items.some(function (i) { return i.selling_plan_allocation; });
        document.querySelectorAll('.gf-cart-banner').forEach(function (b) { b.hidden = !hasSub; });
        // Only a customer-initiated remove/clear may auto-close the drawer.
        // Opening an already-empty cart intentionally leaves it visible.
        if (closeAfterRemoval && cart.item_count === 0) {
          var drawer = gfCartDrawer();
          var dialog = drawer && drawer.querySelector('dialog');
          if (dialog && dialog.open) {
            setTimeout(function () {
              if (typeof drawer.close === 'function') drawer.close();
              else dialog.close();
            }, 350);
          }
        }
      })
      .catch(function () {});
  }
  document.addEventListener('shopify:cart:lines-update', function () {
    setTimeout(gfRefreshCartCount, 150);
    gfQueueReconcile(200);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { gfQueueReconcile(1200); });
  } else {
    gfQueueReconcile(1200);
  }

  var gfSweeping = false;
  function gfReleaseReconcile() {
    gfSweeping = false;
    if (gfReconcileRequested) {
      gfReconcileRequested = false;
      gfQueueReconcile(100);
    }
  }
  function gfReconcileGifts() {
    if (gfSweeping) { gfReconcileRequested = true; return; }
    gfSweeping = true;
    origFetch(gfRoute('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLines = cart.items.filter(function (i) { return i.properties && i.properties._gf_free_gift; });
        var packs = cart.items.filter(function (i) {
          return !(i.properties && i.properties._gf_free_gift) &&
            i.selling_plan_allocation && i.properties && i.properties._gf_gifts;
        });
        if (!giftLines.length && !packs.length) { gfReleaseReconcile(); return; }

        var required = {};
        packs.forEach(function (p) {
          var manifest = p.properties && p.properties._gf_gifts;
          if (!manifest) return;
          manifest.split('|').forEach(function (entry) {
            var f = entry.split('~');
            var id = Number(f[0]);
            if (!id || gfUnavailableGiftIds[id]) return;
            required[id] = {
              plan: f[1] === '1' ? p.selling_plan_allocation.selling_plan.id : null,
              note: f.slice(2).join('~')
            };
          });
        });

        var removals = {};
        giftLines.forEach(function (g) {
          if (!required[g.variant_id]) removals[g.key] = 0;
          else if (g.quantity !== 1) removals[g.key] = 1;
        });
        var additions = [];
        Object.keys(required).forEach(function (idStr) {
          var id = Number(idStr);
          var present = giftLines.some(function (g) { return g.variant_id === id; });
          if (present) return;
          var props = { _gf_free_gift: '1', _gf_gift_program: 'lifetime-subscription-v1' };
          var note = required[idStr].note;
          if (note) {
            var ci = note.indexOf(': ');
            if (ci > 0) props[note.slice(0, ci)] = note.slice(ci + 2);
            else props.Delivery = note;
          }
          var line = { id: id, quantity: 1, properties: props };
          if (required[idStr].plan) line.selling_plan = required[idStr].plan;
          additions.push(line);
        });

        if (!Object.keys(removals).length && !additions.length) { gfReleaseReconcile(); return; }
        var chain = Promise.resolve(null);
        if (Object.keys(removals).length) {
          chain = chain.then(function () {
            return origFetch(gfRoute('cart/update.js') + '?__gfsweep=1', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: removals, sections: 'cart-drawer-section' })
            }).then(function (r) { if (!r.ok) throw new Error('gift cleanup failed'); return r.json(); });
          });
        }
        additions.forEach(function (line) {
          chain = chain.then(function (latestResponse) {
            return origFetch(gfRoute('cart/add.js') + '?__gfsweep=1', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [line], sections: 'cart-drawer-section' })
            }).then(function (r) {
              if (!r.ok) {
                gfUnavailableGiftIds[line.id] = true;
                return latestResponse;
              }
              return r.json();
            });
          });
        });
        chain
          .then(function (json) {
            gfReleaseReconcile();
            if (json && json.sections) {
              var origin = document.querySelector('#cart-drawer .cart-items__wrapper') || document;
              var ev = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
              ev.action = 'update';
              ev.promise = Promise.resolve({ detail: { sections: json.sections } });
              origin.dispatchEvent(ev);
            }
          })
          .catch(gfReleaseReconcile);
      })
      .catch(gfReleaseReconcile);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-gf-mobile-menu-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog) return;
      dialog.__gfOpener = opener;
      opener.setAttribute('aria-expanded', 'true');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      var firstLink = dialog.querySelector('a, button');
      if (firstLink) firstLink.focus();
      return;
    }
    var closer = event.target.closest && event.target.closest('[data-gf-mobile-menu-close]');
    if (closer) {
      var openDialog = closer.closest('[data-gf-mobile-menu]');
      if (openDialog) openDialog.close();
    }
  });

  document.querySelectorAll('[data-gf-mobile-menu]').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      if (!dialog.__gfOpener) return;
      dialog.__gfOpener.setAttribute('aria-expanded', 'false');
      dialog.__gfOpener.focus();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  });

})();

/* Gutful hidden-tab gift reminder */
(() => {
  if (!/^\/products\//.test(window.location.pathname)) return;
  const favicon = document.querySelector('[data-gf-favicon]');
  if (!favicon) return;

  const attentionTitle = "Don't miss your FREE Gifts!";
  const staticHref = favicon.dataset.staticHref || favicon.href;
  const sourceHref = favicon.dataset.sourceHref || 'data:image/png;base64,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';
  const shakeHref = favicon.dataset.shakeHref;
  const nativeGifAnimation = /Firefox\//.test(window.navigator.userAgent);
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const frameOffsets = [0, -4, 4, -3, 3, -2, 2, 0];
  const frameDurations = [700, 65, 65, 65, 65, 65, 65, 900];
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const iconSource = new Image();

  canvas.width = 64;
  canvas.height = 64;
  iconSource.crossOrigin = 'anonymous';
  iconSource.src = sourceHref;

  let restoreTitle = document.title;
  let attentionIsActive = false;
  let sourceIsReady = false;
  let frameTimer;

  const stopFrameAnimation = () => {
    window.clearTimeout(frameTimer);
    frameTimer = undefined;
  };

  const renderBadgeFrame = (offset = 0) => {
    if (!context || !sourceIsReady) return;

    context.clearRect(0, 0, 64, 64);
    context.fillStyle = '#F7F3E8';
    context.fillRect(0, 0, 64, 64);
    context.drawImage(iconSource, offset, 0, 64, 64);

    context.beginPath();
    context.arc(50, 14, 11, 0, Math.PI * 2);
    context.fillStyle = '#E3743B';
    context.fill();
    context.lineWidth = 3;
    context.strokeStyle = '#F7F3E8';
    context.stroke();

    context.fillStyle = '#FFFFFF';
    context.font = '700 14px Arial, sans-serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText('1', 50, 14.5);

    favicon.type = 'image/png';
    favicon.href = canvas.toDataURL('image/png');
  };

  const runFrameAnimation = () => {
    stopFrameAnimation();

    if (nativeGifAnimation && shakeHref && !motionPreference.matches) {
      favicon.type = 'image/gif';
      favicon.href = shakeHref;
      return;
    }

    if (motionPreference.matches) {
      renderBadgeFrame(0);
      return;
    }

    let frameIndex = 0;
    const advanceFrame = () => {
      if (!attentionIsActive) return;

      renderBadgeFrame(frameOffsets[frameIndex]);
      const delay = frameDurations[frameIndex] || 90;
      frameIndex = (frameIndex + 1) % frameOffsets.length;
      frameTimer = window.setTimeout(advanceFrame, delay);
    };

    advanceFrame();
  };

  const showAttentionState = () => {
    if (attentionIsActive) return;

    restoreTitle = document.title;
    attentionIsActive = true;
    document.title = attentionTitle;
    runFrameAnimation();
  };

  const restoreActiveState = () => {
    if (!attentionIsActive) return;

    attentionIsActive = false;
    stopFrameAnimation();
    document.title = restoreTitle;
    favicon.type = 'image/x-icon';
    favicon.href = staticHref;
  };

  const syncVisibilityState = () => {
    if (document.visibilityState === 'hidden') {
      showAttentionState();
    } else {
      restoreActiveState();
    }
  };

  const markSourceReady = () => {
    sourceIsReady = true;
    if (attentionIsActive && !(nativeGifAnimation && shakeHref)) {
      runFrameAnimation();
    }
  };

  if (iconSource.complete && iconSource.naturalWidth > 0) {
    markSourceReady();
  } else {
    iconSource.addEventListener('load', markSourceReady, { once: true });
  }

  document.addEventListener('visibilitychange', syncVisibilityState);
  window.addEventListener('blur', () => {
    window.setTimeout(() => {
      if (!document.hasFocus()) showAttentionState();
    }, 120);
  });
  window.addEventListener('focus', restoreActiveState);
  motionPreference.addEventListener?.('change', () => {
    if (attentionIsActive) runFrameAnimation();
  });

  // Handle product pages that finish loading in an already-backgrounded tab.
  syncVisibilityState();
})();

/* ============================================================
   Gutful storewide chrome JS — cart-drawer enhancements that must
   work on every page (the drawer is global, the PDP scripts are not).
   The inline one-time -> subscription upgrade, plus gift bundling:
   free gifts leave the cart with the pack that granted them.
   ============================================================ */
(function () {
  'use strict';
  if (window.__gfChromeBooted) return;
  window.__gfChromeBooted = true;

  /* -------------------------------------------------------------
     Cart icon → drawer, storewide. This used to live in the PDP
     script, which now only loads on the V3 product template — so the
     icon fell back to navigating to /cart everywhere else. Delegated
     so it survives drawer morphs and section reloads; the PDP script
     marks icons it has already bound, and we honour that flag.
     ------------------------------------------------------------- */
  function gfCartDrawer() { return document.getElementById('cart-drawer'); }
  document.addEventListener('click', function (e) {
    var icon = e.target.closest && e.target.closest('[data-gf-cart-icon]');
    if (!icon || icon.dataset.gfDrawerInit) return; // PDP script owns it there
    var drawer = gfCartDrawer();
    if (!drawer) return; // no drawer on this page — let the link through
    var dialog = drawer.querySelector('dialog');
    if (dialog && dialog.open) {
      e.preventDefault();
      if (typeof drawer.close === 'function') drawer.close();
      else dialog.close();
      return;
    }
    if (typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); return; }
    if (dialog && typeof dialog.showModal === 'function') { e.preventDefault(); dialog.showModal(); }
  });

  /* -------------------------------------------------------------
     Gift bundling — manifest-driven. Each subscription pack line
     carries a hidden _gf_gifts manifest ("id~plan~note|...") written
     at add-to-cart. After every cart mutation (and once on load) the
     reconciler rebuilds the required gift set from the manifests of
     the packs still in the cart: gift lines nothing requires are
     removed, required gifts that are missing are re-added — so gifts
     follow their pack in, out, and across tier switches. Subscription
     lines without a manifest never qualify gifts; orphan gift lines are
     removed instead of being retained by an unrelated subscription.
  ------------------------------------------------------------- */
  var origFetch = window.fetch.bind(window);
  var gfShopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var gfUnavailableGiftIds = {};
  var gfReconcileTimer = null;
  var gfReconcileRequested = false;
  function gfRoute(path) { return gfShopRoot + String(path || '').replace(/^\/+/, ''); }
  function gfQueueReconcile(delay) {
    if (gfReconcileTimer) window.clearTimeout(gfReconcileTimer);
    gfReconcileTimer = window.setTimeout(function () {
      gfReconcileTimer = null;
      gfReconcileGifts();
    }, delay || 0);
  }
  document.addEventListener('gutful:gift:unavailable', function (event) {
    var id = Number(event.detail && event.detail.variantId);
    if (id) gfUnavailableGiftIds[id] = true;
  });

  /* Pack removal is intercepted at the CLICK, before Horizon's own
     handler runs: the rows hide instantly and ONE update.js removes the
     pack and its gifts together. Rewriting the outgoing request was
     unreliable (Horizon's remove button doesn't post a JSON body), which
     left a window where the gifts briefly outlived their pack. */
  var gfCart = null;
  function gfSnapshot() {
    return origFetch(gfRoute('cart.js')).then(function (r) { return r.json(); }).then(function (c) { gfCart = c; return c; });
  }
  gfSnapshot().catch(function () {});

  function gfGiftKeysFor(cart, packKey) {
    var pack = cart.items.filter(function (i) { return i.key === packKey; })[0];
    var manifest = pack && pack.properties && pack.properties._gf_gifts;
    if (!manifest) return null;
    var ids = manifest.split('|').map(function (e) { return Number(e.split('~')[0]); }).filter(Boolean);
    var keep = {};
    cart.items.forEach(function (i) {
      if (i.key === packKey || !i.properties || !i.properties._gf_gifts) return;
      i.properties._gf_gifts.split('|').forEach(function (e) { keep[Number(e.split('~')[0])] = true; });
    });
    var updates = {};
    updates[packKey] = 0;
    cart.items.forEach(function (i) {
      if (!(i.properties && i.properties._gf_free_gift)) return;
      if (ids.indexOf(i.variant_id) !== -1 && !keep[i.variant_id]) updates[i.key] = 0;
    });
    return updates;
  }

  function gfRowsFor(updates) {
    var rows = [];
    Object.keys(updates).forEach(function (k) {
      document.querySelectorAll('[data-key="' + k + '"]').forEach(function (r) { rows.push(r); });
    });
    return rows;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-items__remove');
    if (!btn || !gfCart) return;
    var row = btn.closest('[data-key]');
    if (!row) return;
    var updates = gfGiftKeysFor(gfCart, row.dataset.key);
    // Only take over when this line actually carries gifts.
    if (!updates || Object.keys(updates).length < 2) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    gfRowsFor(updates).forEach(function (r) { r.style.display = 'none'; });
    origFetch(gfRoute('cart/update.js') + '?__gfsweep=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'cart-drawer-section' })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        gfCart = json;
        var origin = document.querySelector('#cart-drawer .cart-items__wrapper') || document;
        var ev = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
        ev.action = 'update';
        ev.promise = Promise.resolve({ detail: { sections: json.sections } });
        origin.dispatchEvent(ev);
        gfRefreshCartCount(true);
      })
      .catch(function () {
        gfRowsFor(updates).forEach(function (r) { r.style.display = ''; });
      });
  }, true);

  function gfRemovalWithGifts(url, init) {
    var body;
    try { body = JSON.parse(init.body); } catch (e) { return null; }
    if (Number(body.quantity) !== 0) return null;
    var key = body.id || body.line;
    if (!key) return null;
    return origFetch(gfRoute('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var target = cart.items.filter(function (i, idx) {
          return i.key === key || String(idx + 1) === String(key) || i.variant_id === Number(key);
        })[0];
        var manifest = target && target.properties && target.properties._gf_gifts;
        if (!manifest) return origFetch(url, init);
        var giftIds = manifest.split('|').map(function (e) { return Number(e.split('~')[0]); }).filter(Boolean);
        // Only drop gifts no OTHER remaining pack still requires.
        var keep = {};
        cart.items.forEach(function (i) {
          if (i === target || !i.properties || !i.properties._gf_gifts) return;
          i.properties._gf_gifts.split('|').forEach(function (e) { keep[Number(e.split('~')[0])] = true; });
        });
        var updates = {};
        updates[target.key] = 0;
        cart.items.forEach(function (i) {
          if (!(i.properties && i.properties._gf_free_gift)) return;
          if (giftIds.indexOf(i.variant_id) !== -1 && !keep[i.variant_id]) updates[i.key] = 0;
        });
        return origFetch(gfRoute('cart/update.js') + '?__gfsweep=1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates, sections: body.sections || 'cart-drawer-section' })
        });
      })
      .catch(function () { return origFetch(url, init); });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/change(\.js)?/.test(url) && url.indexOf('__gfsweep') === -1 && init && init.body) {
      var rewritten = gfRemovalWithGifts(url, init);
      if (rewritten) {
        rewritten.then(function () { setTimeout(function () { gfRefreshCartCount(true); }, 150); }, function () {});
        return rewritten;
      }
    }
    var p = origFetch(input, init);
    if (/\/cart\/(change|update|add|clear)(\.js)?/.test(url) && url.indexOf('__gfsweep') === -1) {
      var closesWhenEmpty = /\/cart\/clear(\.js)?/.test(url);
      if (!closesWhenEmpty && init && init.body) {
        try {
          var mutationBody = JSON.parse(init.body);
          if (/\/cart\/change(\.js)?/.test(url)) closesWhenEmpty = Number(mutationBody.quantity) === 0;
          if (/\/cart\/update(\.js)?/.test(url) && mutationBody.updates) {
            closesWhenEmpty = Object.keys(mutationBody.updates).some(function (key) {
              return Number(mutationBody.updates[key]) === 0;
            });
          }
        } catch (e) { /* non-JSON cart mutations do not auto-close */ }
      }
      // Header bubble must follow EVERY mutation (removals included —
      // Horizon only re-renders the drawer, not our count).
      p.then(function (response) {
        if (response.ok) setTimeout(function () { gfRefreshCartCount(closesWhenEmpty); }, 150);
      }, function () {});
      p.then(function (response) { if (response.ok) gfQueueReconcile(200); }, function () {});
    }
    return p;
  };

  function gfRefreshCartCount(closeAfterRemoval) {
    origFetch(gfRoute('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        gfCart = cart; // keep the snapshot warm for instant removals
        document.querySelectorAll('[data-gf-cart-count]').forEach(function (b) {
          b.textContent = cart.item_count;
          b.hidden = cart.item_count === 0;
        });
        // The free-shipping banner sits outside the nodes Horizon morphs,
        // so it survived an emptied cart. Keep it tied to live cart state.
        var hasSub = cart.items.some(function (i) { return i.selling_plan_allocation; });
        document.querySelectorAll('.gf-cart-banner').forEach(function (b) { b.hidden = !hasSub; });
        // Only a customer-initiated remove/clear may auto-close the drawer.
        // Opening an already-empty cart intentionally leaves it visible.
        if (closeAfterRemoval && cart.item_count === 0) {
          var drawer = gfCartDrawer();
          var dialog = drawer && drawer.querySelector('dialog');
          if (dialog && dialog.open) {
            setTimeout(function () {
              if (typeof drawer.close === 'function') drawer.close();
              else dialog.close();
            }, 350);
          }
        }
      })
      .catch(function () {});
  }
  document.addEventListener('shopify:cart:lines-update', function () {
    setTimeout(gfRefreshCartCount, 150);
    gfQueueReconcile(200);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { gfQueueReconcile(1200); });
  } else {
    gfQueueReconcile(1200);
  }

  var gfSweeping = false;
  function gfReleaseReconcile() {
    gfSweeping = false;
    if (gfReconcileRequested) {
      gfReconcileRequested = false;
      gfQueueReconcile(100);
    }
  }
  function gfReconcileGifts() {
    if (gfSweeping) { gfReconcileRequested = true; return; }
    gfSweeping = true;
    origFetch(gfRoute('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLines = cart.items.filter(function (i) { return i.properties && i.properties._gf_free_gift; });
        var packs = cart.items.filter(function (i) {
          return !(i.properties && i.properties._gf_free_gift) &&
            i.selling_plan_allocation && i.properties && i.properties._gf_gifts;
        });
        if (!giftLines.length && !packs.length) { gfReleaseReconcile(); return; }

        var required = {};
        packs.forEach(function (p) {
          var manifest = p.properties && p.properties._gf_gifts;
          if (!manifest) return;
          manifest.split('|').forEach(function (entry) {
            var f = entry.split('~');
            var id = Number(f[0]);
            if (!id || gfUnavailableGiftIds[id]) return;
            required[id] = {
              plan: f[1] === '1' ? p.selling_plan_allocation.selling_plan.id : null,
              note: f.slice(2).join('~')
            };
          });
        });

        var removals = {};
        giftLines.forEach(function (g) {
          if (!required[g.variant_id]) removals[g.key] = 0;
          else if (g.quantity !== 1) removals[g.key] = 1;
        });
        var additions = [];
        Object.keys(required).forEach(function (idStr) {
          var id = Number(idStr);
          var present = giftLines.some(function (g) { return g.variant_id === id; });
          if (present) return;
          var props = { _gf_free_gift: '1', _gf_gift_program: 'lifetime-subscription-v1' };
          var note = required[idStr].note;
          if (note) {
            var ci = note.indexOf(': ');
            if (ci > 0) props[note.slice(0, ci)] = note.slice(ci + 2);
            else props.Delivery = note;
          }
          var line = { id: id, quantity: 1, properties: props };
          if (required[idStr].plan) line.selling_plan = required[idStr].plan;
          additions.push(line);
        });

        if (!Object.keys(removals).length && !additions.length) { gfReleaseReconcile(); return; }
        var chain = Promise.resolve(null);
        if (Object.keys(removals).length) {
          chain = chain.then(function () {
            return origFetch(gfRoute('cart/update.js') + '?__gfsweep=1', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: removals, sections: 'cart-drawer-section' })
            }).then(function (r) { if (!r.ok) throw new Error('gift cleanup failed'); return r.json(); });
          });
        }
        additions.forEach(function (line) {
          chain = chain.then(function (latestResponse) {
            return origFetch(gfRoute('cart/add.js') + '?__gfsweep=1', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [line], sections: 'cart-drawer-section' })
            }).then(function (r) {
              if (!r.ok) {
                gfUnavailableGiftIds[line.id] = true;
                return latestResponse;
              }
              return r.json();
            });
          });
        });
        chain
          .then(function (json) {
            gfReleaseReconcile();
            if (json && json.sections) {
              var origin = document.querySelector('#cart-drawer .cart-items__wrapper') || document;
              var ev = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
              ev.action = 'update';
              ev.promise = Promise.resolve({ detail: { sections: json.sections } });
              origin.dispatchEvent(ev);
            }
          })
          .catch(gfReleaseReconcile);
      })
      .catch(gfReleaseReconcile);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-gf-mobile-menu-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog) return;
      dialog.__gfOpener = opener;
      opener.setAttribute('aria-expanded', 'true');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      var firstLink = dialog.querySelector('a, button');
      if (firstLink) firstLink.focus();
      return;
    }
    var closer = event.target.closest && event.target.closest('[data-gf-mobile-menu-close]');
    if (closer) {
      var openDialog = closer.closest('[data-gf-mobile-menu]');
      if (openDialog) openDialog.close();
    }
  });

  document.querySelectorAll('[data-gf-mobile-menu]').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      if (!dialog.__gfOpener) return;
      dialog.__gfOpener.setAttribute('aria-expanded', 'false');
      dialog.__gfOpener.focus();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  });

})();

/* Gutful favicon + hidden-tab gift reminder */
(() => {
  const staticIcon = 'data:image/x-icon;base64,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';
  const sourceIcon = 'data:image/png;base64,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';
  let favicon = document.querySelector('link[rel="icon"], link[rel="shortcut icon"]');
  if (!favicon) { favicon = document.createElement('link'); document.head.appendChild(favicon); }
  favicon.rel = 'icon';
  favicon.type = 'image/x-icon';
  favicon.href = staticIcon;
  favicon.setAttribute('data-gf-favicon', '');
  favicon.dataset.staticHref = staticIcon;
  favicon.dataset.sourceHref = sourceIcon;
  document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach((link) => { if (link !== favicon) link.remove(); });

  if (!/^\/products\//.test(window.location.pathname)) return;

  const attentionTitle = "Don't miss your FREE Gifts!";
  const staticHref = favicon.dataset.staticHref || favicon.href;
  const sourceHref = favicon.dataset.sourceHref || staticHref;
  const shakeHref = favicon.dataset.shakeHref;
  const nativeGifAnimation = /Firefox\//.test(window.navigator.userAgent);
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const frameOffsets = [0, -4, 4, -3, 3, -2, 2, 0];
  const frameDurations = [700, 65, 65, 65, 65, 65, 65, 900];
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const iconSource = new Image();

  canvas.width = 64;
  canvas.height = 64;
  iconSource.crossOrigin = 'anonymous';
  iconSource.src = sourceHref;

  let restoreTitle = document.title;
  let attentionIsActive = false;
  let sourceIsReady = false;
  let frameTimer;

  const stopFrameAnimation = () => {
    window.clearTimeout(frameTimer);
    frameTimer = undefined;
  };

  const renderBadgeFrame = (offset = 0) => {
    if (!context || !sourceIsReady) return;

    context.clearRect(0, 0, 64, 64);
    context.fillStyle = '#F7F3E8';
    context.fillRect(0, 0, 64, 64);
    context.drawImage(iconSource, offset, 0, 64, 64);

    context.beginPath();
    context.arc(50, 14, 11, 0, Math.PI * 2);
    context.fillStyle = '#E3743B';
    context.fill();
    context.lineWidth = 3;
    context.strokeStyle = '#F7F3E8';
    context.stroke();

    context.fillStyle = '#FFFFFF';
    context.font = '700 14px Arial, sans-serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText('1', 50, 14.5);

    favicon.type = 'image/png';
    favicon.href = canvas.toDataURL('image/png');
  };

  const runFrameAnimation = () => {
    stopFrameAnimation();

    if (nativeGifAnimation && shakeHref && !motionPreference.matches) {
      favicon.type = 'image/gif';
      favicon.href = shakeHref;
      return;
    }

    if (motionPreference.matches) {
      renderBadgeFrame(0);
      return;
    }

    let frameIndex = 0;
    const advanceFrame = () => {
      if (!attentionIsActive) return;

      renderBadgeFrame(frameOffsets[frameIndex]);
      const delay = frameDurations[frameIndex] || 90;
      frameIndex = (frameIndex + 1) % frameOffsets.length;
      frameTimer = window.setTimeout(advanceFrame, delay);
    };

    advanceFrame();
  };

  const showAttentionState = () => {
    if (attentionIsActive) return;

    restoreTitle = document.title;
    attentionIsActive = true;
    document.title = attentionTitle;
    runFrameAnimation();
  };

  const restoreActiveState = () => {
    if (!attentionIsActive) return;

    attentionIsActive = false;
    stopFrameAnimation();
    document.title = restoreTitle;
    favicon.type = 'image/x-icon';
    favicon.href = staticHref;
  };

  const syncVisibilityState = () => {
    if (document.visibilityState === 'hidden') {
      showAttentionState();
    } else {
      restoreActiveState();
    }
  };

  const markSourceReady = () => {
    sourceIsReady = true;
    if (attentionIsActive && !(nativeGifAnimation && shakeHref)) {
      runFrameAnimation();
    }
  };

  if (iconSource.complete && iconSource.naturalWidth > 0) {
    markSourceReady();
  } else {
    iconSource.addEventListener('load', markSourceReady, { once: true });
  }

  document.addEventListener('visibilitychange', syncVisibilityState);
  window.addEventListener('blur', () => {
    window.setTimeout(() => {
      if (!document.hasFocus()) showAttentionState();
    }, 120);
  });
  window.addEventListener('focus', restoreActiveState);
  motionPreference.addEventListener?.('change', () => {
    if (attentionIsActive) runFrameAnimation();
  });

  // Handle product pages that finish loading in an already-backgrounded tab.
  syncVisibilityState();
})();

